// extracted by mini-css-extract-plugin
export default {"wrap":"SupportEnabledDialog-wrap","password":"SupportEnabledDialog-password"};